import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dropzone from 'react-dropzone';
import moment from 'moment';
import {
  Card,
  CardHeader,
  CardContent,
  Typography,
  Grid,
  Box,
  Button,
  IconButton,
  Checkbox,
  Tooltip,
  Chip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  FormControlLabel,
} from '@material-ui/core';

import VisibilityIcon from '@material-ui/icons/Visibility';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import RefreshIcon from '@material-ui/icons/Refresh';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

import ProgressCircle from './components/ProgressCircle';
import RegisterNewDeposit from './RegisterNewDeposit';
import ActiveDepositsComponent from '../molecules/specialCondition/adddeposit/ActiveDepositsComponent';
import Container from '../atoms/Container/Container';
import { CardWrapper } from './style';
import drawerHoc from '../../../../components/drawerHOC/DrawerHOC';
import { tenantActions } from '../../redux/tenant.actions';
import { TenantService } from '../../redux/tenant.service';
import { navigate } from '../../../../navigation/RootNavigation';
import { showErrorToast, showSuccesToast } from '../helpers';
import { useIsFocused } from '@react-navigation/native';

const formatDate = (date) => (date ? moment(date).format('DD/MM/YYYY') : '');

const AlertBox = ({ severity = 'info', children, style }) => {
  let bg = '#EFF8FF';
  let border = '#B9E6FE';
  let color = '#1E40AF';
  let iconColor = '#0288D1';

  if (severity === 'error') {
    bg = '#FEF2F2';
    border = '#FECACA';
    color = '#991B1B';
    iconColor = '#DC2626';
  } else if (severity === 'warning') {
    bg = '#FFFBEB';
    border = '#FEF08A';
    color = '#92400E';
    iconColor = '#D97706';
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        backgroundColor: bg,
        borderRadius: '8px',
        border: `1px solid ${border}`,
        color: color,
        fontSize: '14px',
        lineHeight: 1.5,
        ...style,
      }}
    >
      <InfoOutlinedIcon style={{ color: iconColor, marginRight: '12px', fontSize: '20px', flexShrink: 0 }} />
      <div style={{ flex: 1 }}>{children}</div>
    </div>
  );
};

const DepositProtectHomeSetup = (props) => {
  const dispatch = useDispatch();
  const focused = useIsFocused();
  const flowId = props?.route?.params?.id;

  const globalState = useSelector((state) => state?.tenant.flowIdInfo);
  const depositProtectData = useSelector((state) => state.tenant?.depositProtectData);

  const [depositCertificates, setDepositCertificates] = useState([]);
  const [prescribedCertificates, setPrescribedCertificates] = useState([]);
  const [depositProtectionData, setDepositProtectionData] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  const [deleteType, setDeleteType] = useState('');

  useEffect(() => {
    if (globalState) {
      const certs = globalState.open_flow_holding_deposit?.deposit_certificate;
      const certs1 = globalState.open_flow_holding_deposit?.prescribed_information_certificate;

      if (certs) {
        try {
          const parsed = JSON.parse(certs);
          setDepositCertificates(Array.isArray(parsed) ? parsed : []);
        } catch (e) {
          setDepositCertificates([]);
        }
      } else {
        setDepositCertificates([]);
      }

      if (certs1) {
        try {
          const parsed1 = JSON.parse(certs1);
          setPrescribedCertificates(Array.isArray(parsed1) ? parsed1 : []);
        } catch (e) {
          setPrescribedCertificates([]);
        }
      } else {
        setPrescribedCertificates([]);
      }
    }
  }, [globalState]);

  useEffect(() => {
    if (flowId) {
      dispatch(tenantActions.getFlowInfo(flowId));
      fetchTdsRecords(flowId);
    }
  }, [flowId, focused]);

  const fetchTdsRecords = (id) => {
    TenantService.getTDSDeposit(id)
      .then((response) => {
        setDepositProtectionData(response?.data);
        dispatch(tenantActions.setDepositData(response?.data));
      })
      .catch(() => {});
  };

  const onRefresh = () => {
    if (flowId) {
      dispatch(tenantActions.getFlowInfo(flowId));
      fetchTdsRecords(flowId);
    }
  };

  const handleMarkAsComplete = (e) => {
    const isChecked = e.target.checked;
    const endpoint = isChecked
      ? `/openflow/property_status/mark-as-complete?flow_id=${flowId}`
      : `/openflow/property_status/mark-as-incomplete?flow_id=${flowId}`;
    dispatch(tenantActions.toggleComplete(endpoint, flowId));
  };

  const onDropCertificate = (data) => {
    if (!data || !data.length) return;
    const newImages = data.map((file) => {
      Object.assign(file, { preview: URL.createObjectURL(file) });
      return file;
    });

    dispatch(
      tenantActions.uploadFiles(newImages, 'deposit_certificate', (uploadResponse) => {
        if (uploadResponse?.data && uploadResponse.data.length) {
          const rawItem = uploadResponse.data[0];
          const fileUrl =
            typeof rawItem === 'string'
              ? rawItem
              : rawItem?.openbrixName || rawItem?.name || rawItem?.url;

          if (!fileUrl) {
            showErrorToast('Failed to get uploaded file URL');
            return;
          }

          const updated = [
            ...depositCertificates,
            {
              document_url: fileUrl,
              is_seen: false,
              deposit_certificate_date: new Date(),
            },
          ];
          setDepositCertificates(updated);
          dispatch(
            tenantActions.saveProtectData(
              {
                flow_id: flowId,
                deposit_certificate: updated,
                prescribed_certificate: prescribedCertificates,
                deleted_certificate: null,
                deleted_prescribed_certificate: null,
              },
              flowId
            )
          );
        }
      })
    );
  };

  const onDropCertificate1 = (data) => {
    if (!data || !data.length) return;
    const newImages = data.map((file) => {
      Object.assign(file, { preview: URL.createObjectURL(file) });
      return file;
    });

    dispatch(
      tenantActions.uploadFiles(newImages, 'prescribed_information_certificate', (uploadResponse) => {
        if (uploadResponse?.data && uploadResponse.data.length) {
          const rawItem = uploadResponse.data[0];
          const fileUrl =
            typeof rawItem === 'string'
              ? rawItem
              : rawItem?.openbrixName || rawItem?.name || rawItem?.url;

          if (!fileUrl) {
            showErrorToast('Failed to get uploaded file URL');
            return;
          }

          const updated1 = [
            ...prescribedCertificates,
            {
              document_url1: fileUrl,
              is_seen1: false,
              prescribed_information_certificate_date: new Date(),
            },
          ];
          setPrescribedCertificates(updated1);
          dispatch(
            tenantActions.saveProtectData(
              {
                flow_id: flowId,
                deposit_certificate: depositCertificates,
                prescribed_certificate: updated1,
                deleted_certificate: null,
                deleted_prescribed_certificate: null,
              },
              flowId
            )
          );
        }
      })
    );
  };

  const handleDelete = (certificate, type) => {
    setSelectedCertificate(certificate);
    setDeleteType(type);
    setShowDeleteModal(true);
  };

  const deleteCertificate = () => {
    if (deleteType === 'deposit_certificate') {
      const remaining = depositCertificates.filter((c) => c.document_url !== selectedCertificate?.document_url);
      setDepositCertificates(remaining);
      dispatch(
        tenantActions.saveProtectData(
          {
            flow_id: flowId,
            deposit_certificate: remaining,
            prescribed_certificate: prescribedCertificates,
            deleted_certificate: selectedCertificate,
            deleted_prescribed_certificate: null,
          },
          flowId,
          true
        )
      );
    } else if (deleteType === 'prescribed_information_certificate') {
      const remaining = prescribedCertificates.filter((c) => c.document_url1 !== selectedCertificate?.document_url1);
      setPrescribedCertificates(remaining);
      dispatch(
        tenantActions.saveProtectData(
          {
            flow_id: flowId,
            deposit_certificate: depositCertificates,
            prescribed_certificate: remaining,
            deleted_certificate: null,
            deleted_prescribed_certificate: selectedCertificate,
          },
          flowId,
          true
        )
      );
    }
    setShowDeleteModal(false);
    setSelectedCertificate(null);
    setDeleteType('');
  };

  const schemeName = globalState?.open_flow_move_in?.open_flow_tenancy_deposit_scheme?.name;
  const containsTDSNI = typeof schemeName === 'string' && schemeName.toLowerCase().includes('tds ni');
  const containsTDS = typeof schemeName === 'string' && schemeName.toLowerCase().includes('tds');
  const containsSDS = typeof schemeName === 'string' && schemeName.toLowerCase().includes('sds');

  const dropzoneStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '20px 15px',
    borderWidth: 2,
    borderRadius: 10,
    borderColor: '#9CC2FF',
    borderStyle: 'dashed',
    backgroundColor: '#F8FBFF',
    cursor: 'pointer',
    minHeight: 110,
    textAlign: 'center',
    transition: 'all 0.2s',
  };

  return (
    <Container style={{ fontWeight: 400 }}>
      <CardWrapper style={{ width: '100%', marginLeft: 0, padding: 0 }}>
        <ProgressCircle props={props} />

        <Card variant="outlined" style={{ padding: '24px', borderRadius: 12, borderColor: '#E2E8F0', marginTop: 16 }}>
          <CardHeader
            style={{ padding: 0 }}
            title={
              <Typography variant="h5" style={{ fontWeight: 700, color: '#1E3A8A', fontSize: 22 }}>
                Deposit Protection & Home Concierge
              </Typography>
            }
            action={
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <FormControlLabel
                  label="Mark As Completed"
                  disabled={globalState?.is_completed}
                  control={
                    <Checkbox
                      checked={globalState?.property_status === 1}
                      onChange={handleMarkAsComplete}
                      name="property_status"
                      color="primary"
                    />
                  }
                />
                <Tooltip title="Refresh">
                  <IconButton size="small" onClick={onRefresh} style={{ color: '#64748B' }}>
                    <RefreshIcon fontSize="small" />
                  </IconButton>
                </Tooltip>
              </div>
            }
            subheader={
              <div style={{ marginTop: 8 }}>
                {!globalState?.is_renewed && (
                  <Typography variant="body1" style={{ color: '#475569', fontSize: 15, marginBottom: 12 }}>
                    Protect the Deposit and arrange all the utility and home set-up connections for your Tenants.
                  </Typography>
                )}
                <AlertBox severity="info">
                  {globalState?.is_renewed
                    ? 'If you change the amount of the deposit, you must re-protect it and re-serve the Prescribed Information.'
                    : 'You must protect the tenant(s) deposit by using a Government approved tenancy deposit protection scheme (TDP). NOTE You must do this within 30 days of receiving the funds NOT 30 days from the start of the tenancy. Once the deposit is protected you MUST re-send the Prescribed Information (PI). You can do this from this screen, simply drag and drop the PI into the box below, together with the Deposit Protection Certificate and it will be sent to the tenant(s).'}
                </AlertBox>
              </div>
            }
          />

          <CardContent style={{ padding: '24px 0 0 0' }}>
            <Grid container spacing={3}>
              {/* Deposit Protection Certificate Card */}
              <Grid item xs={12}>
                <Card variant="outlined" style={{ borderRadius: 8, borderColor: '#E2E8F0' }}>
                  <CardHeader
                    title={
                      <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#1E3A8A', fontSize: 17 }}>
                        Deposit Protection Certificate
                      </Typography>
                    }
                  />
                  <CardContent>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={12} sm={4} md={3}>
                        <Dropzone onDrop={onDropCertificate}>
                          {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                              {...getRootProps()}
                              style={{
                                ...dropzoneStyle,
                                backgroundColor: isDragActive ? '#EAF4FF' : '#F8FBFF',
                                borderColor: isDragActive ? '#1976D2' : '#9CC2FF',
                              }}
                            >
                              <input {...getInputProps()} />
                              <CloudUploadIcon style={{ fontSize: 36, color: '#1976D2', marginBottom: 6 }} />
                              <Typography variant="body2" style={{ color: '#475569', fontSize: 13, fontWeight: 500 }}>
                                Drag 'n' drop or click here to select a certificate file
                              </Typography>
                            </div>
                          )}
                        </Dropzone>
                      </Grid>

                      <Grid item xs={12} sm={8} md={9}>
                        {depositCertificates.length === 0 ? (
                          <div style={{ padding: '16px', color: '#94A3B8', fontSize: 14, fontStyle: 'italic' }}>
                            No deposit protection certificates uploaded yet.
                          </div>
                        ) : (
                          depositCertificates.map((item, index) => (
                            <Card
                              key={index}
                              variant="outlined"
                              style={{
                                borderRadius: 8,
                                borderColor: '#E2E8F0',
                                marginBottom: 10,
                                backgroundColor: '#FAFAFA',
                              }}
                            >
                              <CardHeader
                                style={{ padding: '10px 16px' }}
                                title={
                                  <Typography variant="body2" style={{ fontWeight: 600, color: '#1E293B' }}>
                                    Deposit document {depositCertificates.length >= 1 ? index + 1 : ''}
                                  </Typography>
                                }
                                action={
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <Typography variant="body2" style={{ color: '#64748B', fontSize: 13 }}>
                                      {formatDate(item.deposit_certificate_date)}
                                    </Typography>
                                    <Chip
                                      size="small"
                                      variant="outlined"
                                      label={item.is_seen ? 'Seen' : 'Not Seen'}
                                      style={{
                                        borderColor: item.is_seen ? '#22C55E' : '#EF4444',
                                        color: item.is_seen ? '#16A34A' : '#DC2626',
                                        fontWeight: 600,
                                        height: 22,
                                        fontSize: '0.75rem',
                                      }}
                                    />
                                    <Tooltip title="View Certificate">
                                      <IconButton
                                        onClick={() => window.open(item.document_url, '_blank')}
                                        size="small"
                                        style={{ color: '#0288D1' }}
                                      >
                                        <VisibilityIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete Certificate">
                                      <IconButton
                                        onClick={() => handleDelete(item, 'deposit_certificate')}
                                        size="small"
                                        style={{ color: '#DC2626' }}
                                      >
                                        <DeleteOutlineIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                }
                              />
                            </Card>
                          ))
                        )}
                      </Grid>
                    </Grid>

                    {/* TDS / SDS Registration Section */}
                    {(containsTDS || containsSDS || containsTDSNI) && (
                      <div style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid #F1F5F9' }}>
                        {depositProtectionData?.tenancy_deposit_amount_protect ? (
                          <ActiveDepositsComponent
                            totalAmount={`£${depositProtectionData?.tenancy_deposit_amount_protect}`}
                            openflow_id={flowId}
                            data={[
                              {
                                id: depositProtectionData?.batch_id ? depositProtectionData?.batch_id : 'N/A',
                                amount: `£${depositProtectionData?.tenancy_deposit_amount_protect}`,
                                status: depositProtectionData?.tds_deposit_status ? depositProtectionData?.tds_deposit_status : 'SAVED',
                                dpc_file_path: depositProtectionData?.dpc_file_path,
                                submittedOn: depositProtectionData?.holding_desposit_received_date
                                  ? new Date(depositProtectionData?.holding_desposit_received_date).toLocaleDateString()
                                  : '',
                              },
                            ]}
                          />
                        ) : (
                          <RegisterNewDeposit
                            onAddDeposit={() => {
                              navigate('RegisterDeposit', { id: flowId });
                            }}
                          />
                        )}
                      </div>
                    )}
                  </CardContent>
                </Card>
              </Grid>

              {/* Prescribed Information Card */}
              <Grid item xs={12}>
                <Card variant="outlined" style={{ borderRadius: 8, borderColor: '#E2E8F0' }}>
                  <CardHeader
                    title={
                      <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#1E3A8A', fontSize: 17 }}>
                        Prescribed Information
                      </Typography>
                    }
                  />
                  <CardContent>
                    <Grid container spacing={3} alignItems="center">
                      <Grid item xs={12} sm={4} md={3}>
                        <Dropzone onDrop={onDropCertificate1}>
                          {({ getRootProps, getInputProps, isDragActive }) => (
                            <div
                              {...getRootProps()}
                              style={{
                                ...dropzoneStyle,
                                backgroundColor: isDragActive ? '#EAF4FF' : '#F8FBFF',
                                borderColor: isDragActive ? '#1976D2' : '#9CC2FF',
                              }}
                            >
                              <input {...getInputProps()} />
                              <CloudUploadIcon style={{ fontSize: 36, color: '#1976D2', marginBottom: 6 }} />
                              <Typography variant="body2" style={{ color: '#475569', fontSize: 13, fontWeight: 500 }}>
                                Drag 'n' drop or click here to select a certificate file
                              </Typography>
                            </div>
                          )}
                        </Dropzone>
                      </Grid>

                      <Grid item xs={12} sm={8} md={9}>
                        {prescribedCertificates.length === 0 ? (
                          <div style={{ padding: '16px', color: '#94A3B8', fontSize: 14, fontStyle: 'italic' }}>
                            No prescribed information certificates uploaded yet.
                          </div>
                        ) : (
                          prescribedCertificates.map((item, index) => (
                            <Card
                              key={index}
                              variant="outlined"
                              style={{
                                borderRadius: 8,
                                borderColor: '#E2E8F0',
                                marginBottom: 10,
                                backgroundColor: '#FAFAFA',
                              }}
                            >
                              <CardHeader
                                style={{ padding: '10px 16px' }}
                                title={
                                  <Typography variant="body2" style={{ fontWeight: 600, color: '#1E293B' }}>
                                    Prescribed Information {prescribedCertificates.length >= 1 ? index + 1 : ''}
                                  </Typography>
                                }
                                action={
                                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                    <Typography variant="body2" style={{ color: '#64748B', fontSize: 13 }}>
                                      {formatDate(item?.prescribed_information_certificate_date)}
                                    </Typography>
                                    <Chip
                                      size="small"
                                      variant="outlined"
                                      label={item?.is_seen1 ? 'Seen' : 'Not Seen'}
                                      style={{
                                        borderColor: item?.is_seen1 ? '#22C55E' : '#EF4444',
                                        color: item?.is_seen1 ? '#16A34A' : '#DC2626',
                                        fontWeight: 600,
                                        height: 22,
                                        fontSize: '0.75rem',
                                      }}
                                    />
                                    <Tooltip title="View Certificate">
                                      <IconButton
                                        onClick={() => window.open(item?.document_url1, '_blank')}
                                        size="small"
                                        style={{ color: '#0288D1' }}
                                      >
                                        <VisibilityIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Delete Certificate">
                                      <IconButton
                                        onClick={() => handleDelete(item, 'prescribed_information_certificate')}
                                        size="small"
                                        style={{ color: '#DC2626' }}
                                      >
                                        <DeleteOutlineIcon fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </div>
                                }
                              />
                            </Card>
                          ))
                        )}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>

              {/* Home Concierge / Utility Setup */}
              <Grid item xs={12}>
                <Card variant="outlined" style={{ borderRadius: 8, borderColor: '#E2E8F0', overflow: 'hidden' }}>
                  <CardHeader
                    title={
                      <Typography variant="subtitle1" style={{ fontWeight: 700, color: '#1E3A8A', fontSize: 17 }}>
                        Home Concierge & Utilities
                      </Typography>
                    }
                  />
                  <CardContent style={{ padding: 0 }}>
                    <div style={{ height: 420, width: '100%' }}>
                      <iframe
                        width="100%"
                        height="100%"
                        frameBorder="0"
                        src="https://partners.staging.home.cc/tlyfe/tile"
                        title="Home box"
                      />
                    </div>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </CardWrapper>

      {/* Delete Confirmation Modal */}
      <Dialog open={showDeleteModal} onClose={() => setShowDeleteModal(false)}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure, You want to delete this certificate.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setShowDeleteModal(false)} variant="outlined" color="default">
            No
          </Button>
          <Button onClick={deleteCertificate} variant="contained" style={{ backgroundColor: '#DC2626', color: '#FFFFFF' }}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default drawerHoc({
  Component: DepositProtectHomeSetup,
  showBackButton: true,
  backNavigation: 'CurrentOnboards',
});
